import { render, staticRenderFns } from "./IndexV2.vue?vue&type=template&id=f4ceba02"
import script from "./IndexV2.vue?vue&type=script&lang=js"
export * from "./IndexV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports